module.exports = __webpack_public_path__ + "static/media/18ECA48.6a5ecfd2.jpg";